export default {
    messageTitle: '消息中心',
    messageCenterClose: '消息中心已关闭，无法接受消息推送',
    openNotification: '去开启',
    noData: '暂无消息',
    loadingFailed: '加载失败',
    systemNotion: '系统公告',
    businessNotion: '业务提醒',
    activityNotion: '活动提醒',
    serviceNotion: '联系客服',
    toServeYou: '很高兴为您服务',
    viewDetails: '查看详情',
    productName: '产品名称：',
    amount: '订单金额：',
    filledAmount: '确认金额：',
    parValue: '票面面额：',
    filledQuantity: '确认份额：',
    filledPrice: '成交净值：',
    confirmedPrice: '确认价格：',
    accruedInterest: '应付利息：',
    informationTitle: '复星财富早知道',
}
